import { create } from 'zustand';

export const useAuthStore = create((set) => ({
  user: null,
  userProfile: null,
  isAuthenticated: false,
  isInitialized: false, // 초기 인증 체크 완료 여부

  setUser: (user, userProfile = null) => set({
    user,
    userProfile,
    isAuthenticated: !!user,
    isInitialized: true
  }),

  setUserProfile: (userProfile) => set((state) => ({
    userProfile: { ...state.userProfile, ...userProfile }
  })),

  clearUser: () => set({
    user: null,
    userProfile: null,
    isAuthenticated: false,
    isInitialized: true
  }),
}));
